<h4>{{ field.label }}</h4>
<div class="p-grid">
  <div class="p-col-6" *ngFor="let reward of record[field.key]">
    <ul>
      <ng-container *ngIf="reward.lineItemType !== 'Item'; else itemBlock">
        <ng-container *ngIf="reward.lineItemType !== 'SeedPackBox'; else seedPackBoxBlock">
          <li *ngIf="reward.lineItemType !== 'Currency'; else currencyBlock">
            <img *ngIf="reward.id?.image_ref" [src]="reward.id.image_ref.thumbnail_url_32 + '?ts=' + timestamp" class="reward-image" alt="">
            <span class="reward-count">{{ reward.c | number }}</span>
            <span *ngIf="reward.id && reward.id.name">{{ reward.id.name }} ({{ reward.id.id }})</span>
            <span *ngIf="!reward.id || !reward.id.name" class="text-muted">No item selected</span>
          </li>
        </ng-container>
      </ng-container>

      <ng-template #itemBlock>
        <li>
          <span class="reward-count">{{ reward.c | number }}</span>
          <a *ngIf="reward.id && reward.id.name" href="/items/{{ reward.id.id }}" target="_blank" class="item-link">{{ reward.id.name }} ({{ reward.id.id }})</a>
          <span *ngIf="!reward.id || !reward.id.name" class="text-muted">No item selected</span>
        </li>
      </ng-template>

      <ng-template #seedPackBoxBlock>
        <li>
          <span class="reward-count">{{ reward.c | number }}</span>
          <img *ngIf="reward.id?.box_image_ref" [src]="reward.id.box_image_ref.thumbnail_url_32 + '?ts=' + timestamp" class="reward-image" alt="">
          <a *ngIf="reward.id && reward.id.name" href="/seed-pack-box/{{ reward.id.id }}" target="_blank" class="item-link">{{ reward.id.name }} ({{ reward.id.id }})</a>
          <span *ngIf="!reward.id || !reward.id.name" class="text-muted">No item selected</span>
        </li>
      </ng-template>

      <ng-template #currencyBlock>
        <li>
          <img *ngIf="reward.id?.image_ref" [src]="reward.id.image_ref.thumbnail_url_32 + '?ts=' + timestamp" class="reward-image" alt="">
          <span class="reward-count">{{ reward.c | number }}</span>
          <a *ngIf="reward.id && reward.id.name" href="/currencies/{{ reward.id.id }}" target="_blank" class="item-link">{{ reward.id.name }} ({{ reward.id.id }})</a>
          <span *ngIf="!reward.id || !reward.id.name" class="text-muted">No item selected</span>
        </li>
      </ng-template>
    </ul>
  </div>
</div>
